import React, { useEffect } from "react";
import { createPortal } from "react-dom";
import "../../styles/modal.css";
import { separateNumber } from "utils/helpers";

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  price: number;
}

const Modal: React.FC<ModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  price,
}) => {
  // Блокируем прокрутку body, пока открыта модалка
// Modal.tsx
useEffect(() => {
  if (!isOpen) return;

  const scrollBarWidth = window.innerWidth - document.documentElement.clientWidth;

  const prevOverflow = document.body.style.overflow;
  const prevPaddingRight = document.body.style.paddingRight;

  document.body.style.overflow = "hidden";
  if (scrollBarWidth > 0) {
    document.body.style.paddingRight = `${scrollBarWidth}px`;
  }

  return () => {
    document.body.style.overflow = prevOverflow || "auto";
    document.body.style.paddingRight = prevPaddingRight || "";
  };
}, [isOpen]);



  // Закрытие по Esc
  useEffect(() => {
    if (!isOpen) return;
    const onKeyDown = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [isOpen, onClose]);

  // Закрытие по клику на подложку
  const handleBackdropClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget) onClose();
  };

  if (!isOpen) {
    return null;
  }

  const node = (
    <div
      className="app-modal"
      role="dialog"
      aria-modal="true"
      onClick={handleBackdropClick}
    >
      <div className="app-modal__content">
        <p>
          Купить {title} стоимостью {separateNumber(price)} старок?
        </p>

        <div className="app-modal__buttons">
          <button
            className="app-modal__button app-modal__button--cancel"
            onClick={onClose}
          >
            Нет
          </button>

          <button
            className="app-modal__button app-modal__button--confirm"
            onClick={onConfirm}
          >
            Да
          </button>
        </div>
      </div>
    </div>
  );

  return createPortal(node, document.body);
};

export default Modal;
